mpangoApp.factory('Mcontribution',['$http', 'Upload', function($http,Upload) {
	return{
		getContr : function() {
			return $http.get('index.php/api/getcontr');
		},
		postContr : function(contrdata) {
			return $http({
				method: 'POST',
				url: 'index.php/api/postcontr',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':contrdata}
			
			});
		},
		updateContr : function(contrdata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updatecontr',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':contrdata, 'formname':formname}
			
			});
		},
		postXls : function(xlsdata) {
			return Upload.upload({
				method: 'POST',
				url: 'index.php/api/postxls',
				data: xlsdata
			});
		},
	}
}]);